// 기본 이미지 URL 상수
export const LEGACY_ECOPACK_IMAGE_URL = 'https://undalhijwbpyvohuykcn.supabase.co/storage/v1/object/public/bucket1/product_images/deadline_product_base/image.png';
export const DEFAULT_ECOPACK_IMAGE_URL = '/images/products/image.png';
